<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{ folio ? "Editar" : "Registrar" }} bono
            {{ folio ? `Folio:${folio}` : "" }}
            <router-link :to="{ name: 'Bono', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <BonoForm
              :isLoadingPage="isLoadingPage"
              :ubicaciones="ubicaciones"
              :trabajadores="trabajadores"
              :ubicacionesAll="ubicacionesAll"
              :trabajadoresAll="trabajadoresAll"
              :fetching="fetching"
              @handledSubmit="(fn) => (handledSubmit = fn)"
              @setData="(fn) => (setData = fn)"
              @onFetch="
                () => {
                  fetching = false;
                }
              "
              @onErrorFetch="
                (err) => {
                  fetching = false;
                  error = err;
                  warningModal = true;
                }
              "
              :pushMedia="pushMedia"
            />

            <div class="mask-edit" v-if="folio && isLoadingPage">
              <div
                class="w-100 d-flex justify-content-center align-items-center"
              >
                <div class="sk-flow flex align-items-center">
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Bono', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton
              v-else
              @click="addBonoItem()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Bono"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >
        {{ error }}
      </CModal>
      <CModal
        size="sm"
        title="Bono"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="closeModal" color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import moment from "moment";

import BonoForm from "@/forms/BonoForm.vue";

export default {
  name: "NuevoBono",

  components: {
    BonoForm,
  },

  data() {
    return {
      folio: this.$route.params.folio,
      date: "",
      fechaInicial: null,
      fechaFinal: null,
      multi: null,
      config: this.$route.params.config,
      semanas: 1,
      concepto: "",
      nanoid: undefined,
      item: {},
      tipo_costo: null,
      tiposCosto: [
        { value: "cosecha", label: "Cosecha" },
        { value: "no_cosecha", label: "No cosecha" },
      ],
      monto: null,
      trabajador: null,
      trabajadores: [],
      trabajadoresAll: [],
      // categoria: null,
      categorias: [],
      categoriasAll: [],
      actividad: null,
      actividades: [],
      actividadesAll: [],
      ubicacion: null,
      ubicaciones: [],
      ubicacionesAll: [],
      tiempo_extra: false,
      isFijo: false,
      isLoading: false,
      isLoadingPage: false,
      unidad: "kg",
      unidadPagar: "dia",
      currentAlertCounter: 0,
      warningModal: false,
      successModal: false,
      error: "",
      comentarios: "",
      fetching: false,
      medias: [],

      handledSubmit: () => {},
      setData: () => {},
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required,
    },
    concepto: {
      required,
    },
    monto: {
      required,
    },
    tipo_costo: {
      required,
    },
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidConcepto() {
      return !this.$v.concepto.$invalid;
    },
    isValidMonto() {
      return !this.$v.monto.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    isValidTipoCosto() {
      return !this.$v?.tipo_costo.$invalid;
    },
  },

  watch: {
    ubicacionRaiz: function () {
      this.updateCombos();
    },
  },

  created() {
    this.$store.dispatch("getNanoid");
    this.isLoadingPage = true;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "trabajadores",
        filter: {
          where: [
            {
              field: "payload->ubicaciones",
              operator: "regexp",
              value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`,
            },
            {
              field: "payload->suspendido",
              operator: "=",
              value: false,
            },
          ],
        },
      }),
    ];

    if (this.ubicacionRaizValue) {
      ubi.push(
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaizValue,
                operator: "=",
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ],
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      );
    } else {
      ubi.push(
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ],
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      );
    }
    if (this.folio) {
      ubi.push(
        this.$store.dispatch("customDocumentoHTTP", {
          schema: "bonos",
          filter: {
            wherein: [
              {
                field: "payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaizValue],
              },
            ],
            where: [
              {
                field: "folio",
                value: this.folio,
                operator: "=",
              },
            ],
          },
          ["with-storage"]: ["*"],
        })
      );
    }

    Promise.all(ubi)
      .then(([trabajadores, ubicaciones, item]) => {
        this.trabajadores = trabajadores.data.map((trabajador) => {
          return { value: trabajador.id, label: trabajador.payload.nombre };
        });
        this.ubicaciones = ubicaciones.data.map((ubicacion) => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.ubicacionesAll = ubicaciones.data;
        this.trabajadoresAll = trabajadores.data;

        if (item) {
          this.item = item.data[0];
          const form = {
            date: "",
            trabajador: null,
            ubicaciones: null,
            fechaInicial: null,
            fechaFinal: null,
            concepto: "",
            monto: null,
            tipo_costo: null,
            comentarios: "",
            medias: [],
          };
          const trabajador = trabajadores.data.find(
            (f) => f.id === this.item.payload.encabezado.trabajador_id
          );
          form.trabajador = {
            value: trabajador.id,
            label: trabajador.payload.nombre,
          };
          form.concepto = this.item.payload.encabezado.concepto;
          this.nanoid = this.item.payload.encabezado.nanoid;
          form.monto = this.item.payload.encabezado.monto;
          form.fechaInicial = moment(
            this.item.payload.encabezado.fecha_inicial,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          form.fechaFinal = moment(
            this.item.payload.encabezado.fecha_final,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          form.comentarios = this.item.payload.encabezado.comentarios;
          form.medias = this.item.payload.anexos;
          form.tipo_costo = this.tiposCosto.find(
            (f) => f.value == this.item.payload.encabezado.tipo_costo
          );

          const newMult = this.item.payload.encabezado._relaciones.ubicacion
            .filter((ubi) => ubi.id)
            .map((ubicacion) => {
              return { value: ubicacion.id, label: ubicacion.payload.nombre };
            });
          form.ubicaciones = newMult;

          form.date = moment(
            this.item.payload.encabezado.fechahora,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          this.setData(form);
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    closeModal() {
      this.successModal = false;
      if (this.folio) {
        this.$router.push({ name: "Bono" });
      }
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    updateCombos() {
      this.isLoadingPage = true;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaizValue],
              },
            ],
            where: [
              {
                field: "payload->suspendido",
                operator: "=",
                value: false,
              },
            ],
          },
        }),
      ];

      if (this.ubicacionRaizValue) {
        ubi.push(
          this.$store.dispatch("customHTTP", {
            schema: "ubicaciones",
            filter: {
              where: [
                {
                  field: "payload->raiz_id",
                  value: this.ubicacionRaizValue,
                  operator: "=",
                },
                {
                  field: "payload->suspendido",
                  value: false,
                  operator: "="
                }
              ],
            },
            order:[{
              field: 'payload->nombre',
              direction: 'asc'
            }]
          })
        );
      } else {
        ubi.push(
          this.$store.dispatch("customHTTP", {
            schema: "ubicaciones",
            filter: {
              where: [
                {
                  field: "payload->suspendido",
                  value: false,
                  operator: "="
                }
              ],
            },
            order:[{
              field: 'payload->nombre',
              direction: 'asc'
            }]
          })
        );
      }

      Promise.all(ubi)
        .then(([trabajadores, ubicaciones]) => {
          this.trabajadores = trabajadores.data.map((trabajador) => {
            return { value: trabajador.id, label: trabajador.payload.nombre };
          });
          this.trabajadoresAll = trabajadores.data;
          this.ubicaciones = ubicaciones.data.map((ubicacion) => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    async addBonoItem() {
      this.fetching = true;
      this.isLoading = true;
      await new Promise((res) => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            this.error = "";
            clearInterval(iter);
            res();
          }
        }, 1000);
      });
      this.isLoading = false;

      if (this.error) {
        this.successModal = false;
        return;
      }
      const form = this.handledSubmit();
      console.log(form);
      if (form.skip) {
        return;
      }
      if (form.error && form.warningModal) {
        this.error = form.error;
        this.warningModal = form.warningModal;
        return;
      }
      if (this.folio) {
        form.folio = this.folio;
        form.payload.encabezado.nanoid = this.nanoid;
      }

      this.$store
        .dispatch(
          this.folio
            ? "customDocumentoRemplazarHTTP"
            : "customDocumentoAddHTTP",
          form
        )
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch((rej) => {
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })

        .finally(() => {
          this.isLoading = false;
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateBono() {
      this.$v.date.$touch();
      this.$v.concepto.$touch();
      this.$v.monto.$touch();
      this.$v.tipo_costo.$touch();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
